export default defineNuxtPlugin(async () => {
  const { getGuestCartId } = useGuestCart();
  const userSession = useUserSession();
//   const cartId = userSession.value?.guest_cart_id
//   if (!cartId.value) {
//     await getGuestCartId();
//   }
})